module.exports = __webpack_public_path__ + "static/media/knob.979f1ef6.png";